import { X } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

type Props = {
  files: File[]
  onFilesUpdated(files: File[]): void
}

const FileAttachmentsList = ({ files, onFilesUpdated }: Props) => {
  if (!files || files.length === 0) return null

  const removeFile = (indexToRemove: number) => {
    const updatedFiles = Array.from(files).filter((_, i) => i !== indexToRemove)

    onFilesUpdated(updatedFiles)
  }

  return (
    <div className="mt-2 flex max-h-[200px] min-h-[40px] flex-wrap gap-2 overflow-y-auto px-4 pt-2">
      {Array.from(files).map((file, index) => {
        return (
          <Badge className="flex items-center gap-2 pr-1" key={file.name} variant="secondary">
            <span className="max-w-[150px] truncate">{file.name}</span>
            <span className="text-xs opacity-70">{(file.size / 1024).toFixed(1)} KB</span>
            <button
              className="hover:bg-muted-foreground/10 ml-1 rounded-full p-0.5"
              onClick={() => removeFile(index)}
              type="button"
            >
              <X className="text-muted-foreground" size={14} />
            </button>
          </Badge>
        )
      })}
    </div>
  )
}

export default FileAttachmentsList
